import { Component, OnDestroy, OnInit } from '@angular/core';
import { OrderState } from '@app/_models';
import { LoggerService, OrderService } from '@app/_services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-order-unlock',
  templateUrl: './order-unlock.component.html',
  styleUrls: ['./order-unlock.component.sass']
})
export class OrderUnlockComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();

  // Order table
  dataSource: OrderState[] = [];
  displayedColumns: string[] = ['id_ordine_ps', 'stato', 'data_import'];

  // Order search
  numeroOrdine: string = "";
  statoOrdine: number = 0; //0 sconosciuto, 1 ok, -1 male etc
  statoDescrizione: string = "Elaborato";

  constructor(
    private orderService: OrderService,
    private logger: LoggerService
  ) { }

  ngOnInit(): void {
    this.orderService.downloadOrderStateList()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: statuses => this.dataSource = statuses,
        error: err => this.logger.error('downloadOrderStateList failed:', err)
      });
    //load order state from DB, post current date, a limit ...
  }

  checkOrderStatus() {
    this.logger.log('Controllo su ordine:', this.numeroOrdine);
    this.statoOrdine = -1;
  }

  unlockOrder() {
    this.logger.log('Unlock ordine:', this.numeroOrdine);
    this.statoOrdine = 1;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
